import script from "./MultilingualInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultilingualInput.vue?vue&type=script&setup=true&lang=ts"

import "./MultilingualInput.vue?vue&type=style&index=0&id=0b7b8278&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b7b8278"]])

export default __exports__